import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuthFetch } from "../hooks/useAuthFetch";
import "../stili/MonitoraggioNotifichePagamenti.css";

const API_URL = process.env.REACT_APP_API_URL;

const ESITI_OPTIONS = [
  { value: "", label: "Tutti" },
  { value: "INVIATA", label: "Inviata" },
  { value: "FALLITA", label: "Fallita" },
];

const TIPI_NOTIFICA_OPTIONS = [
  { value: "", label: "Tutti" },
  { value: "PROMEMORIA_PRE_SCADENZA", label: "Promemoria pre scadenza" },
  { value: "SCADENZA_ODIERNA", label: "Scadenza odierna" },
  { value: "SOLLECITO_7_GIORNI", label: "Sollecito 7 giorni" },
  { value: "SOLLECITO_15_GIORNI", label: "Sollecito 15 giorni" },
  { value: "SOLLECITO_SCADUTO", label: "Sollecito scaduto" },
];

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    borderRadius: 14,
    background: "rgba(255,255,255,0.10)",
    borderColor: state.isFocused
      ? "rgba(255,255,255,0.45)"
      : "rgba(255,255,255,0.18)",
    boxShadow: "none",
    color: "#fff",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  }),
  menu: (base) => ({
    ...base,
    background: "rgba(15, 23, 52, 0.96)",
    border: "1px solid rgba(255,255,255,0.14)",
    borderRadius: 14,
    overflow: "hidden",
    zIndex: 30,
  }),
  singleValue: (base) => ({ ...base, color: "#fff" }),
  input: (base) => ({ ...base, color: "#fff" }),
  placeholder: (base) => ({ ...base, color: "rgba(255,255,255,0.70)" }),
  option: (base, state) => ({
    ...base,
    background: state.isFocused ? "rgba(255,255,255,0.10)" : "transparent",
    color: "#fff",
    cursor: "pointer",
  }),
};

const prettifyEnum = (value) => {
  if (!value) return "-";
  return String(value)
    .replaceAll("_", " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("it-IT");
};

function DettaglioNotificaModal({ notifica, onClose }) {
  if (!notifica) return null;

  return (
    <div className="monitor-notifiche-modal-overlay" onClick={onClose}>
      <div
        className="monitor-notifiche-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="monitor-notifiche-modal-header">
          <h3>Dettaglio notifica</h3>
          <button
            type="button"
            className="monitor-notifiche-close-btn"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <div className="monitor-notifiche-modal-grid">
          <div className="monitor-notifiche-detail-card">
            <span className="label">Data invio</span>
            <span className="value">{formatDateTime(notifica.dataInvio)}</span>
          </div>

          <div className="monitor-notifiche-detail-card">
            <span className="label">Esito</span>
            <span className="value">{prettifyEnum(notifica.esito)}</span>
          </div>

          <div className="monitor-notifiche-detail-card">
            <span className="label">Tipo notifica</span>
            <span className="value">{prettifyEnum(notifica.tipoNotifica)}</span>
          </div>

          <div className="monitor-notifiche-detail-card">
            <span className="label">Canale</span>
            <span className="value">{notifica.canale || "-"}</span>
          </div>

          <div className="monitor-notifiche-detail-card">
            <span className="label">Giocatore</span>
            <span className="value">{notifica.giocatore || "-"}</span>
          </div>

          <div className="monitor-notifiche-detail-card">
            <span className="label">Genitore</span>
            <span className="value">{notifica.genitore || "-"}</span>
          </div>

          <div className="monitor-notifiche-detail-card">
            <span className="label">Categoria</span>
            <span className="value">{notifica.categoria || "-"}</span>
          </div>

          <div className="monitor-notifiche-detail-card">
            <span className="label">Stagione</span>
            <span className="value">{notifica.stagione || "-"}</span>
          </div>
        </div>

        <div className="monitor-notifiche-detail-block">
          <h4>Oggetto</h4>
          <div className="monitor-notifiche-pre">
            {notifica.oggetto || "Nessun oggetto"}
          </div>
        </div>

        <div className="monitor-notifiche-detail-block">
          <h4>Messaggio inviato</h4>
          <div className="monitor-notifiche-pre">
            {notifica.messaggio || "Nessun messaggio disponibile"}
          </div>
        </div>

        <div className="monitor-notifiche-detail-block">
          <h4>Errore</h4>
          <div className="monitor-notifiche-pre error">
            {notifica.errore || "Nessun errore registrato"}
          </div>
        </div>

        <div className="monitor-notifiche-modal-actions">
          <button
            type="button"
            className="monitor-notifiche-btn secondary"
            onClick={onClose}
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
}

export default function MonitoraggioNotifichePagamenti() {
  const navigate = useNavigate();
  const authFetch = useAuthFetch();

  const [stagioni, setStagioni] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [genitori, setGenitori] = useState([]);
  const [giocatori, setGiocatori] = useState([]);

  const [notifiche, setNotifiche] = useState([]);
  const [selectedNotifica, setSelectedNotifica] = useState(null);

  const [loadingLookupBase, setLoadingLookupBase] = useState(false);
  const [loadingGiocatori, setLoadingGiocatori] = useState(false);
  const [loading, setLoading] = useState(false);
  const [esecuzioneLoading, setEsecuzioneLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [size] = useState(12);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  const [filtri, setFiltri] = useState({
    idStagione: "",
    idCategoria: "",
    idGiocatore: "",
    idGenitore: "",
    esito: "",
    tipoNotifica: "",
    dataDa: "",
    dataA: "",
  });

  const stagioneOptions = useMemo(
    () => [
      { value: "", label: "Tutte" },
      ...stagioni.map((s) => ({
        value: s.id,
        label: s.nome || `Stagione ${s.id}`,
      })),
    ],
    [stagioni]
  );

  const categoriaOptions = useMemo(
    () => [
      { value: "", label: "Tutte" },
      ...categorie.map((c) => ({
        value: c.id,
        label: c.nome || `Categoria ${c.id}`,
      })),
    ],
    [categorie]
  );

  const genitoreOptions = useMemo(
    () => [
      { value: "", label: "Tutti" },
      ...genitori.map((g) => ({
        value: g.id,
        label: `${g.cognome || ""} ${g.nome || ""}`.trim(),
      })),
    ],
    [genitori]
  );

  const giocatoreOptions = useMemo(
    () => [
      { value: "", label: "Tutti" },
      ...giocatori.map((g) => ({
        value: g.id,
        label: `${g.cognome || ""} ${g.nome || ""}`.trim(),
      })),
    ],
    [giocatori]
  );

  useEffect(() => {
    const fetchLookupBase = async () => {
      setLoadingLookupBase(true);
      try {
        const [resStagioni, resCategorie, resGenitori] = await Promise.all([
          authFetch(`${API_URL}/api/admin/lookup/stagioni`),
          authFetch(`${API_URL}/api/admin/lookup/categorie`),
          authFetch(`${API_URL}/api/admin/lookup/genitori`),
        ]);

        if (!resStagioni.ok || !resCategorie.ok || !resGenitori.ok) {
          throw new Error("Errore lookup base");
        }

        const dataStagioni = await resStagioni.json().catch(() => []);
        const dataCategorie = await resCategorie.json().catch(() => []);
        const dataGenitori = await resGenitori.json().catch(() => []);

        setStagioni(Array.isArray(dataStagioni) ? dataStagioni : []);
        setCategorie(Array.isArray(dataCategorie) ? dataCategorie : []);
        setGenitori(Array.isArray(dataGenitori) ? dataGenitori : []);
      } catch (err) {
        console.error("fetchLookupBase error", err);
        toast.error("Errore caricamento stagioni, categorie o genitori.");
      } finally {
        setLoadingLookupBase(false);
      }
    };

    fetchLookupBase();
  }, [authFetch]);

  useEffect(() => {
    const fetchGiocatori = async () => {
      setLoadingGiocatori(true);
      try {
        const params = new URLSearchParams();

        if (filtri.idCategoria) {
          params.append("idCategoria", filtri.idCategoria);
        }
        if (filtri.idStagione) {
          params.append("idStagione", filtri.idStagione);
        }

        const url = `${API_URL}/api/admin/lookup/giocatori${
          params.toString() ? `?${params.toString()}` : ""
        }`;

        const res = await authFetch(url);

        if (!res.ok) {
          throw new Error("Errore lookup giocatori");
        }

        const data = await res.json().catch(() => []);
        setGiocatori(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("fetchGiocatori error", err);
        setGiocatori([]);
        toast.error("Errore caricamento giocatori.");
      } finally {
        setLoadingGiocatori(false);
      }
    };

    fetchGiocatori();
  }, [authFetch, filtri.idCategoria, filtri.idStagione]);

  useEffect(() => {
    const fetchNotificheIniziali = async () => {
      setLoading(true);

      try {
        const payload = {
          idStagione: null,
          idCategoria: null,
          idGiocatore: null,
          idGenitore: null,
          esito: null,
          tipoNotifica: null,
          dataDa: null,
          dataA: null,
        };

        const res = await authFetch(
          `${API_URL}/api/admin/notifiche-pagamenti/storico/ricerca?page=0&size=${size}&sort=dataInvio&dir=DESC`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        );

        if (!res.ok) {
          throw new Error(`Errore caricamento iniziale: ${res.status}`);
        }

        const data = await res.json().catch(() => null);
        const rawContent = Array.isArray(data?.content) ? data.content : [];

        setNotifiche(rawContent);
        setPage(data?.number ?? 0);
        setTotalPages(data?.totalPages ?? 0);
        setTotalElements(data?.totalElements ?? 0);
      } catch (err) {
        console.error("fetchNotificheIniziali error", err);
        setNotifiche([]);
        setPage(0);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Errore durante il caricamento iniziale dello storico.");
      } finally {
        setLoading(false);
      }
    };

    fetchNotificheIniziali();
  }, [authFetch, size]);

  const loadNotifiche = async (targetPage = 0, filtriDaUsare = filtri) => {
    setLoading(true);

    try {
      const payload = {
        idStagione: filtriDaUsare.idStagione || null,
        idCategoria: filtriDaUsare.idCategoria || null,
        idGiocatore: filtriDaUsare.idGiocatore || null,
        idGenitore: filtriDaUsare.idGenitore || null,
        esito: filtriDaUsare.esito || null,
        tipoNotifica: filtriDaUsare.tipoNotifica || null,
        dataDa: filtriDaUsare.dataDa || null,
        dataA: filtriDaUsare.dataA || null,
      };

      const res = await authFetch(
        `${API_URL}/api/admin/notifiche-pagamenti/storico/ricerca?page=${targetPage}&size=${size}&sort=dataInvio&dir=DESC`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        throw new Error(`Errore ricerca storico: ${res.status}`);
      }

      const data = await res.json().catch(() => null);
      const rawContent = Array.isArray(data?.content) ? data.content : [];

      setNotifiche(rawContent);
      setPage(data?.number ?? targetPage ?? 0);
      setTotalPages(data?.totalPages ?? 0);
      setTotalElements(data?.totalElements ?? 0);
    } catch (err) {
      console.error("loadNotifiche error", err);
      setNotifiche([]);
      setPage(0);
      setTotalPages(0);
      setTotalElements(0);
      toast.error("Errore durante il caricamento dello storico notifiche.");
    } finally {
      setLoading(false);
    }
  };

  const eseguiInvioManuale = async () => {
    setEsecuzioneLoading(true);
    try {
      const res = await authFetch(
        `${API_URL}/api/admin/notifiche-pagamenti/esegui`,
        { method: "POST" }
      );

      if (!res.ok) {
        throw new Error("Errore esecuzione manuale");
      }

      const data = await res.json().catch(() => null);

      toast.success(
        `Procedura eseguita. Inviate: ${data?.inviate ?? 0}, fallite: ${
          data?.fallite ?? 0
        }, saltate: ${data?.saltate ?? 0}.`
      );

      loadNotifiche(0);
    } catch (err) {
      console.error("eseguiInvioManuale error", err);
      toast.error("Errore durante l'esecuzione manuale.");
    } finally {
      setEsecuzioneLoading(false);
    }
  };

  const onFiltroChange = (name, value) => {
    setFiltri((prev) => {
      const updated = { ...prev, [name]: value };

      if (name === "idCategoria" || name === "idStagione") {
        updated.idGiocatore = "";
      }

      return updated;
    });
  };

  const onCerca = () => {
    loadNotifiche(0, filtri);
  };

  const onReset = () => {
    const reset = {
      idStagione: "",
      idCategoria: "",
      idGiocatore: "",
      idGenitore: "",
      esito: "",
      tipoNotifica: "",
      dataDa: "",
      dataA: "",
    };

    setFiltri(reset);
    loadNotifiche(0, reset);
  };

  return (
    <div className="sfondo-immagine">
      <div className="monitor-notifiche-page">
        <div className="monitor-notifiche-container">
          <div className="monitor-notifiche-header-card">
            <div>
              <h2 className="monitor-notifiche-title">
                Monitoraggio Notifiche Pagamenti
              </h2>
              <p className="monitor-notifiche-subtitle">
                Storico email inviate dal sistema con filtri, esito e dettaglio
                messaggio.
              </p>
            </div>

            <div className="monitor-notifiche-header-actions">
              <button
                type="button"
                className="monitor-notifiche-btn secondary"
                onClick={() => navigate("/gestionale2")}
              >
                Torna al Gestionale
              </button>

              <button
                type="button"
                className="monitor-notifiche-btn primary"
                onClick={eseguiInvioManuale}
                disabled={esecuzioneLoading}
              >
                {esecuzioneLoading
                  ? "Esecuzione in corso..."
                  : "Esegui procedura manuale"}
              </button>
            </div>
          </div>

          <div className="monitor-notifiche-filtri-card">
            <h3>Filtri ricerca</h3>

            <div className="monitor-notifiche-filtri-grid">
              <div className="monitor-notifiche-field">
                <label>Stagione</label>
                <Select
                  styles={selectStyles}
                  options={stagioneOptions}
                  value={
                    stagioneOptions.find(
                      (opt) => String(opt.value) === String(filtri.idStagione)
                    ) || stagioneOptions[0]
                  }
                  onChange={(opt) =>
                    onFiltroChange("idStagione", opt?.value || "")
                  }
                  isLoading={loadingLookupBase}
                />
              </div>

              <div className="monitor-notifiche-field">
                <label>Categoria</label>
                <Select
                  styles={selectStyles}
                  options={categoriaOptions}
                  value={
                    categoriaOptions.find(
                      (opt) => String(opt.value) === String(filtri.idCategoria)
                    ) || categoriaOptions[0]
                  }
                  onChange={(opt) =>
                    onFiltroChange("idCategoria", opt?.value || "")
                  }
                  isLoading={loadingLookupBase}
                />
              </div>

              <div className="monitor-notifiche-field">
                <label>Giocatore</label>
                <Select
                  styles={selectStyles}
                  options={giocatoreOptions}
                  value={
                    giocatoreOptions.find(
                      (opt) => String(opt.value) === String(filtri.idGiocatore)
                    ) || giocatoreOptions[0]
                  }
                  onChange={(opt) =>
                    onFiltroChange("idGiocatore", opt?.value || "")
                  }
                  isLoading={loadingGiocatori}
                />
              </div>

              <div className="monitor-notifiche-field">
                <label>Genitore</label>
                <Select
                  styles={selectStyles}
                  options={genitoreOptions}
                  value={
                    genitoreOptions.find(
                      (opt) => String(opt.value) === String(filtri.idGenitore)
                    ) || genitoreOptions[0]
                  }
                  onChange={(opt) =>
                    onFiltroChange("idGenitore", opt?.value || "")
                  }
                  isLoading={loadingLookupBase}
                />
              </div>

              <div className="monitor-notifiche-field">
                <label>Esito</label>
                <Select
                  styles={selectStyles}
                  options={ESITI_OPTIONS}
                  value={
                    ESITI_OPTIONS.find(
                      (opt) => String(opt.value) === String(filtri.esito)
                    ) || ESITI_OPTIONS[0]
                  }
                  onChange={(opt) => onFiltroChange("esito", opt?.value || "")}
                />
              </div>

              <div className="monitor-notifiche-field">
                <label>Tipo notifica</label>
                <Select
                  styles={selectStyles}
                  options={TIPI_NOTIFICA_OPTIONS}
                  value={
                    TIPI_NOTIFICA_OPTIONS.find(
                      (opt) =>
                        String(opt.value) === String(filtri.tipoNotifica)
                    ) || TIPI_NOTIFICA_OPTIONS[0]
                  }
                  onChange={(opt) =>
                    onFiltroChange("tipoNotifica", opt?.value || "")
                  }
                />
              </div>

              <div className="monitor-notifiche-field">
                <label>Data da</label>
                <input
                  type="date"
                  value={filtri.dataDa}
                  onChange={(e) => onFiltroChange("dataDa", e.target.value)}
                />
              </div>

              <div className="monitor-notifiche-field">
                <label>Data a</label>
                <input
                  type="date"
                  value={filtri.dataA}
                  onChange={(e) => onFiltroChange("dataA", e.target.value)}
                />
              </div>
            </div>

            <div className="monitor-notifiche-actions">
              <button
                type="button"
                className="monitor-notifiche-btn primary"
                onClick={onCerca}
                disabled={loading}
              >
                Cerca
              </button>

              <button
                type="button"
                className="monitor-notifiche-btn secondary"
                onClick={onReset}
                disabled={loading}
              >
                Reset filtri
              </button>
            </div>
          </div>

          <div className="monitor-notifiche-risultati-card">
            <div className="monitor-notifiche-risultati-header">
              <h3>Storico notifiche</h3>
              <span>{totalElements} risultati</span>
            </div>

            {loading ? (
              <div className="monitor-notifiche-empty">Caricamento in corso...</div>
            ) : notifiche.length === 0 ? (
              <div className="monitor-notifiche-empty">
                Nessuna notifica trovata con i filtri selezionati.
              </div>
            ) : (
              <div className="monitor-notifiche-list">
                {notifiche.map((item, index) => (
                  <div className="monitor-notifiche-item" key={item.id || index}>
                    <div className="monitor-notifiche-item-top">
                      <div>
                        <h4>{item.giocatore || "Giocatore non disponibile"}</h4>
                        <p>
                          {item.genitore || "-"} • {item.categoria || "-"} •{" "}
                          {item.stagione || "-"}
                        </p>
                      </div>

                      <div
                        className={`monitor-notifiche-badge ${
                          item.esito === "INVIATA" ? "success" : "error"
                        }`}
                      >
                        {prettifyEnum(item.esito)}
                      </div>
                    </div>

                    <div className="monitor-notifiche-item-grid">
                      <div>
                        <span className="small-label">Data invio</span>
                        <strong>{formatDateTime(item.dataInvio)}</strong>
                      </div>

                      <div>
                        <span className="small-label">Tipo</span>
                        <strong>{prettifyEnum(item.tipoNotifica)}</strong>
                      </div>

                      <div>
                        <span className="small-label">Canale</span>
                        <strong>{item.canale || "-"}</strong>
                      </div>

                      <div>
                        <span className="small-label">Oggetto</span>
                        <strong>{item.oggetto || "-"}</strong>
                      </div>
                    </div>

                    <div className="monitor-notifiche-item-actions">
                      <button
                        type="button"
                        className="monitor-notifiche-btn secondary"
                        onClick={() => setSelectedNotifica(item)}
                      >
                        Dettaglio
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="monitor-notifiche-pagination">
              <button
                type="button"
                className="monitor-notifiche-btn secondary"
                onClick={() => loadNotifiche(page - 1, filtri)}
                disabled={page <= 0 || loading}
              >
                Precedente
              </button>

              <span>
                Pagina {totalPages === 0 ? 0 : page + 1} di {totalPages}
              </span>

              <button
                type="button"
                className="monitor-notifiche-btn secondary"
                onClick={() => loadNotifiche(page + 1, filtri)}
                disabled={page + 1 >= totalPages || loading}
              >
                Successiva
              </button>
            </div>
          </div>
        </div>

        <DettaglioNotificaModal
          notifica={selectedNotifica}
          onClose={() => setSelectedNotifica(null)}
        />
      </div>
    </div>
  );
}